module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_11-3a1bcf854631e3697ad7702950d5855a.png";